import { TriangleAlert } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';

/** The scanned items do not add up to the total and nobody has edited them yet. */
export function ScanNotReconciledWarning({
  className = '',
}: {
  className?: string;
}) {
  const { t } = useTranslation('expenses');
  return (
    <p
      data-testid="scan-not-reconciled"
      className={`flex items-start gap-2 text-sm text-warning-700 dark:text-warning-400 ${className}`}
    >
      <TriangleAlert aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
      <span>{t('scan.notReconciled')}</span>
    </p>
  );
}
